import { selectAllImports } from '@user/store/import/slice'
import { useSelector } from 'react-redux'

export function useRows() {
  const rows = useSelector(selectAllImports)

  return rows
}
